import { render, staticRenderFns } from "./CompanyProjectCard.vue?vue&type=template&id=0cdc7a01&scoped=true&"
import script from "./CompanyProjectCard.vue?vue&type=script&lang=js&"
export * from "./CompanyProjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc7a01",
  null
  
)

export default component.exports